import { List, ListItem, styled, Tooltip } from '@mui/material'
import { PropsWithChildren } from 'react'

export type AuditLogTooltipProps = {
  items: string[]
}

const TooltipList = styled(List)({
  listStyleType: 'disc',
  marginLeft: 24,
})

const TooltipListItem = styled(ListItem)({
  display: 'list-item',
  color: 'white !important',
  paddingBottom: 2,
  paddingTop: 2,
  paddingLeft: 0,
})

export const AuditLogTooltip: React.FC<PropsWithChildren<AuditLogTooltipProps>> = ({ children, items }) => {
  return (
    <Tooltip
      placement="bottom"
      title={
        <TooltipList>
          {items.map((item, index) => (
            <TooltipListItem key={index}>{item}</TooltipListItem>
          ))}
        </TooltipList>
      }
    >
      <span>{children}</span>
    </Tooltip>
  )
}
